var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { HttpClient } from "@/lib/http";
const FETCH_ASSIGNED_OBJECTIVES = "/webapi/objetivos/assigned";
/**
 * Single fetch that builds both title maps from one HTTP call to
 * /webapi/objetivos/assigned. The caller passes both maps to getTableFields():
 * - titleMap: used by applyTitles for all non-Canarias regions
 * - canariasOverrides: used by tableFieldsCanarias for the 4 slot-type variants
 */
export function fetchObjectiveTitleMaps(table) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield HttpClient.get(FETCH_ASSIGNED_OBJECTIVES, { table });
            const titleMap = new Map(response.data.map((o) => [o.type, o.name]));
            const canariasOverrides = new Map(response.data.map((o) => {
                var _a, _b, _c, _d;
                return [
                    o.type,
                    {
                        title_volumen: (_a = o.title_volumen) !== null && _a !== void 0 ? _a : null,
                        title_volumen_pct: (_b = o.title_volumen_pct) !== null && _b !== void 0 ? _b : null,
                        title_clientes: (_c = o.title_clientes) !== null && _c !== void 0 ? _c : null,
                        title_clientes_pct: (_d = o.title_clientes_pct) !== null && _d !== void 0 ? _d : null,
                    },
                ];
            }));
            return { titleMap, canariasOverrides };
        }
        catch (e) {
            console.warn("Failed to load assigned objective titles:", e);
            return {
                titleMap: new Map(),
                canariasOverrides: new Map(),
            };
        }
    });
}
